import { db, doc, setDoc } from "../firebase"; // adjust path as needed

export const sendMail = async (formData) => {
  const { name, mobile, email, country, query } = formData;

  const mailData = {
    to: email,
    enquiry: {
      type: "Query",
      name: name || "",
      mobile: mobile || "",
      email: email || "",
      country: country || "",
      query: query || "",
      createdAt: Date.now(),
    },
    message: {
      subject: `Thanks for Your Query, ${name}`,
      text: `Thank you ${formData.name} for contacting Pixwala. We'll get back to you soon.`,
      html: `

  <div style="font-family: Fredoka, sans-serif; max-width: 600px; margin: auto; border-radius: 10px; overflow: hidden; background-color: #202b45; color: #ffffff; padding: 30px 20px; text-align: center;">
    
    <!-- Logo
    <img src="./horizontal-logo.png"
         alt="Pixwala Logo"
         style="width: 100px; height: auto; margin-bottom: 20px;" />
 -->
    <!-- Heading -->
    <h2 style="color: #ffffff; font-family: 'Nulshock', sans-serif; margin: 0 0 10px; font-size: 18px;">
      Thank You for Contacting Pixwala!
    </h2>

    <!-- Services Text -->
    <p style="font-size: 15px; margin: 10px 0 0;color: #ffffff;">
        We are specialized in:
    </p>
    <p style="color: #ff7b00; font-size: 18px; margin: 5px 0 15px;">
    Graphic Design | Photo & Video Shoots | Video Editing
    </p>


    <!-- CTA Button -->
    <a href="https://pixwala.com"
       style="display: inline-block; background-color: #ff7b00; color: #ffffff; font-weight: 500; font-family: 'Fredoka', sans-serif; padding: 10px 20px; border-radius: 5px; text-decoration: none; font-size: 14px; margin-bottom: 30px;">
      Visit Our Website
    </a>

    <!-- Greeting -->
    <p style="font-size: 16px; text-align: left; margin-top: 30px; color: #ffffff;">
      Dear <strong>${name}</strong>,
    </p>

       <!-- Confirmation Message -->
    <p style="font-size: 15px; text-align: left;color: #ffffff;">
     Thank you for reaching out with your query.<br>
Our team will get back to you within 1 working day (Indian Standard Time), Stay tune.<br>
We appreciate your patience and look forward to helping you.<br><br>


    </p>

    <!-- Table of User Details -->
    <table style="width: 100%; margin-top: 15px; font-size: 14px; text-align: left;">
      <tr>
        <td style="font-weight: 500; padding: 8px 0; color: #ffffff;">Name:</td>
        <td>${name}</td>
      </tr>
      <tr>
        <td style="font-weight: 500; padding: 8px 0; color: #ffffff;">Mobile:</td>
        <td>${mobile}</td>
      </tr>
      <tr>
        <td style="font-weight: 500; padding: 8px 0; color: #ffffff;">Email:</td>
        <td style="color: #ffffff;">${email}</td>
      </tr>
      <tr>
        <td style="font-weight: 500; padding: 8px 0; color: #ffffff;">Query:</td>
        <td>${query}</td>
      </tr>
    </table>

     <!-- Follow Up -->
    <p style="margin-top: 20px; text-align: left; color: #ffffff;">
      We’ll get back to you as soon as possible.<br><br>
     Note: For any urgent task, call us directly at 
  <span style="color: #ff7b00;">+91 86996-21455</span>, 

    </p>

    <!-- Signature -->
    <p style="color: #ff7b00; font-size: 16px; text-align: left;">- Team Pixwala</p>

    <!-- Footer -->
    <div style="margin-top: 30px; font-size: 12px; color: #ccc; text-align: center;">
     Pixwala: Turning Pixels Into Possiblities
    </div>
  </div>

`,
    },
  };

  try {
    await setDoc(doc(db, "mail", `${Date.now()}`), mailData);
    console.log("✅ Email request sent and query stored in Firestore.");
  } catch (error) {
    console.error("❌ Error sending email or saving query:", error); // <-- include `error`
    throw error;
  }
};
